import * as db from '../../db'
// import firebase from 'firebase'
import _ from 'lodash'

export const RECEIVE_IPACKAGES = 'RECEIVE_IPACKAGES'
export const LOADING_IPACKAGES = 'LOADING_IPACKAGES'
export const SET_IPACKAGE = 'SET_IPACKAGE'

// initial state
const state = {
  loading: false,
  ipackages: {},
  selectedIpackage: {}
}

// getters
const getters = {
  ipackages: state => _.values(state.ipackages),
  loading: state => state.loading,
  selectedIpackage: state => state.selectedIpackage
}

// actions
const actions = {
  getIpackages ({ commit }) {
    commit(LOADING_IPACKAGES, true)
    db.ipackages.onSnapshot(function (snapshot) {
      let ipackages = {}
      snapshot.forEach(doc => {
        let ipackage = doc.data()
        ipackage.id = doc.id
        ipackages[ipackage.id] = ipackage
      })
      commit(RECEIVE_IPACKAGES, { ipackages })
    })
    commit(LOADING_IPACKAGES, false)
  },
  setIpackage ({ commit }, selectedIpackage) {
    commit(SET_IPACKAGE, selectedIpackage)
  }
}

// mutations
const mutations = {
  [RECEIVE_IPACKAGES] (state, { ipackages }) {
    state.ipackages = ipackages
  },

  [SET_IPACKAGE] (state, selectedIpackage) {
    state.selectedIpackage = selectedIpackage
  },

  [LOADING_IPACKAGES] (state, value) {
    state.loading = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/ipackage.js